export const SET_INITIAL_LOCATION_QUESTION = 'SET_INITIAL_LOCATION_QUESTION';
export const SAVE_VALUE_COUNTRY_QUESTION_LOCATION = 'SAVE_VALUE_COUNTRY_QUESTION_LOCATION';
export const SAVE_VALUE_DEPARTMENT_QUESTION_LOCATION = 'SAVE_VALUE_DEPARTMENT_QUESTION_LOCATION';
export const DELETE_VALUE_DEPARTMENT_QUESTION_LOCATION = 'DELETE_VALUE_DEPARTMENT_QUESTION_LOCATION';
export const GET_COUNTRIES_QUESTION_SURVEY = "GET_COUNTRIES_QUESTION_SURVEY";
export const GET_DEPARTMENTS_QUESTION_SURVEY = "GET_DEPARTMENTS_QUESTION_SURVEY";
export const GET_CITIES_QUESTION_SURVEY = "GET_CITIES_QUESTION_SURVEY";
